import styled from 'styled-components';
import theme from 'styled-theming';

const subTabBackground = theme('name', {
  light: 'rgb(242, 242, 242)',
  dark: '#1C1C1C',
});

export const MessagingContainer = styled.div`
  padding: 5px 15px 10px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .sub-tab {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: ${subTabBackground};
    margin: -5px -15px 0;
    padding: 5px 15px 0;
  }

  .sub-tab > .shell-tabs-nav {
    border-bottom: 1px solid ${(props) => props.theme.border.medium};
  }

  .content {
    flex: 1;
    min-height: 0;
    padding-top: 24px;
    padding-bottom: 8px;
    display: flex;
    flex-direction: column;
  }
`;
